module.exports = __webpack_public_path__ + "img/advertising_03.e41815c0.png";